import { runTheNumbers, updateChart, updateRows, reChart, duplicateRows, productRow, addModalDataToRow} from './functions-scenarios.js';

var doc = $( document );

///////////// SCENARIO PROPERTIES (page header) ////////////////////////

doc.on( 'change', '#target-nitrogen', function () {

	$( '.btn-save' ).removeClass( 'disabled' );
	$('#save-scenario').addClass('dirty');

	// for the save
	$( 'input.target-nitrogen-hidden' ).val( this.value );

	reChart( Number( this.value ) );

} );

doc.on( 'change keyup paste click', '#coverage', function () {

	// $( '.bags' ).data( 'acres', this.value );
	// $( '.gallons' ).data( 'acres', this.value );

	updateRows();

} );

doc.on( 'change', '.scenario-zone-select', function (){

	$('#save-scenario').addClass('dirty');

	var zoneId = $(this).val()
	$('input.zone').val(zoneId)

	var data = {
		zoneId: zoneId
	};

	var tokenName = window.csrfTokenName;
	data[ tokenName ] = window.csrfTokenValue;

	$.ajax( {
		type: "post",
		url: '',
		data: data,
		url: '/actions/tnt/scenarios/get-zone',
		success: function ( response ) {

			zone = JSON.parse(response);

			chartData = runTheNumbers();

			updateChart( chartData );

			updateRows();

		},
		error: function ( XMLHttpRequest, textStatus ) {

			console.log( "Status: " + textStatus );

		}
	} );


} );

///////////// SCENARIO (APPLICATION) TABLE ////////////////////////

doc.on( 'change keyup paste click', '#scenario-table .row-price-input', function (){

	$('#save-scenario').addClass('dirty');

	updateRows();

});

doc.on( 'change', '#scenario-table .product-week-select', function () {

	$( '.btn-save' ).removeClass( 'disabled' );
	$('#save-scenario').addClass('dirty');

	var rowId = $( this ).parents( 'tr' ).attr( 'id' );
	var week = this.value;

	$( '#' + rowId + ' .read-only-details .product-week').text( weeksArray[week-1] )

	if (week.toString().length == 1) {
		var paddedweek = "0" + week;
	} else {
		paddedweek = week
	}

	$( '#' + rowId + ' td:nth-of-type(2)' ).attr('data-order', paddedweek)

	//$('#scenario-table').DataTable().order();
	//$('#scenario-table').DataTable().draw();

	for ( var x = 0; x < jsApplications.length; x ++ ) {

		if ( jsApplications[ x ][ "rowId" ] == rowId ) {

			jsApplications[ x ][ "week" ] = week;

		}

	}

	chartData = runTheNumbers();

	updateChart( chartData );


} );

doc.on( 'change', '#scenario-table .product-select', function () {

	$( '.btn-save' ).removeClass( 'disabled' );
	$( '.btn-product-info' ).removeClass( 'disabled' );

	$('#save-scenario').addClass('dirty');

	var productSelect = $( this );
	var rowId = productSelect.parents( 'tr' ).attr( 'id' );
	var productId = productSelect.val();

	productRow(productSelect,productId,rowId)

} );

doc.on( 'change keyup paste click', '#scenario-table .row-weight-input', function () {

	$( '.btn-save' ).removeClass( 'disabled' );
	$('#save-scenario').addClass('dirty');

	var rowId = $( this ).parents( 'tr' ).attr( 'id' );
	var weight = this.value;

	for ( var x = 0; x < jsApplications.length; x ++ ) {

		if ( jsApplications[ x ][ "rowId" ] == rowId ) {

			jsApplications[ x ][ "weight" ] = weight;

		}

	}

	chartData = runTheNumbers();

	updateChart( chartData );

	updateRows();

} );

doc.on( 'blur', '#scenario-table .row-weight-input', function () {
	var val = $(this).val()
	$(this).val( Number(val).toFixed(1) )
});

///////////// ROW CONTROLS ////////////////////////

doc.on( 'click', '.add-a-row a:not(.disabled)', function (e) {

	e.preventDefault()
	$('#save-scenario').addClass('dirty');

	$( '.btn-save' ).removeClass( 'disabled' );

	var productType = $( this ).data( 'value' );
	var turfType = $('.turf-type-hidden').val();
	var country =  $('.country-hidden').val();
	var week =  $('#scenario-table tbody tr:last-of-type .scenario-week').text();

	if (productType == "foliar") {
		productType = ['foliar','foliarSg']
	}

	var data = {
		productType: productType,
		turfType: turfType,
		country: country,
		week: week, 
		productId: null, 
		rate: "0.0", 
		price: "0.00", 
		copies: "1", 
		interval: "1" 
	};

	// include csrf token
	var tokenName = window.csrfTokenName;
	data[ tokenName ] = window.csrfTokenValue;

	$.ajax( {
		type: "post",
		url: '',
		data: data,
		url: '/actions/tnt/scenarios/get-products-by-type',
		success: function ( response ) {

			//makeNewRow( JSON.parse( response ) );
			duplicateRows( JSON.parse( response ), data );


		},
		error: function ( XMLHttpRequest, textStatus ) {

			console.log( "Status: " + textStatus );

		}
	} );


} );

doc.on( 'click', '.row-delete', function () {

	$( '.btn-save' ).removeClass( 'disabled' );
	$('#save-scenario').addClass('dirty');

	var rowId = $( this ).parents( 'tr' ).attr( 'id' );

	for ( var x = 0; x < jsApplications.length; x ++ ) {

		if ( jsApplications[ x ][ "rowId" ] == rowId ) {

			jsApplications.splice( x, 1 );

		}

	}

	// null out the carryover IN value
	if ( rowId == "row-carryover" ) {

		$('.carryover-in-hidden').val(null)
		$('.carryover-in-profile-hidden').val(null)

	}

	$( this ).closest( "tr" ).remove();

	$('#scenario-table').DataTable().row( $( this ).parents( 'tr' ) ).remove();

	chartData = runTheNumbers();

	updateChart( chartData );

	updateRows();

} );

doc.on( 'click', '.toggle-row-visibility', function () {

	$( '.btn-save' ).removeClass( 'disabled' );

	var viz = $( this );
	var rowId = viz.parents( 'tr' ).attr( 'id' );

	if ( viz.hasClass( 'fa-eye' ) ) {

		viz.removeClass( 'fa-eye' );
		viz.addClass( 'fa-eye-slash' );
		viz.parents( 'tr' ).addClass( 'hidden' );
		viz.parents( 'tr select.product-select' ).attr( 'disabled', 'disabled' );

		if ( rowId == "row-carryover" ) {

			// do something?

		} else {

			$('#'+rowId+' .row-visible').val(0)

			for ( var x = 0; x < jsApplications.length; x ++ ) {

				if ( jsApplications[ x ][ "rowId" ] == rowId ) {

					jsApplications[ x ][ "visible" ] = false;

				}

			}

		}

	} else {

		viz.removeClass( 'fa-eye-slash' );
		viz.addClass( 'fa-eye' );
		viz.parents( 'tr' ).removeClass( 'hidden' );
		viz.parents( 'tr select.product-select' ).removeAttr( 'disabled' );

		if ( rowId == "row-carryover" ) {

			// do something?

		} else {

		$('#'+rowId+' .row-visible').val(1)

			for ( var x = 0; x < jsApplications.length; x ++ ) {

				if ( jsApplications[ x ][ "rowId" ] == rowId ) {

					jsApplications[ x ][ "visible" ] = true;

				}

			}
		}

	}

	chartData = runTheNumbers();

	updateChart( chartData );

	updateRows();

} );

///////////// MODAL STUFF ////////////////////////

doc.on( 'change', '.dtr-bs-modal .product-select', function () {

	var modal = $(".dtr-bs-modal")
	var productId = this.value
	var showPricing = $('.show-pricing-hidden').val()

	$.getJSON( "/products.json", function(response) {

			// find the selected product / product data from our JSON feed
			var data = response.data;
			var product = data.filter(function( obj ) {
				return obj["id"] == productId;
			});
			product = product[0]

			// set our newly selected product data to the contents of this hidden element
			modal.find('.product-data').text( JSON.stringify(product) )

			// for the rate units switching. foliar / foliarSg

			// get the type on the select
			var prevType = modal.find('.product-select').attr('data-product-type')

			// switch when applicable
			if ( product.typeHandle == "foliar" && prevType == "foliarSg" ) {
				modal.find('.weight-unit').html('oz/1000 ft<sup>2</sup>')
			}

			if ( product.typeHandle == "foliarSg" && prevType == "foliar") {
				modal.find('.weight-unit').html('lbs/acre')
			}
			// set the type on the select
			modal.find('.product-select').attr('data-product-type', product.typeHandle)

			// add he proper typeHandle to the cell data
			var rowId = modal.find('.dt-row-id').text()
			var row = $('#' + rowId)

			row.find('.bags').attr('data-type', product.typeHandle)
			row.find('.gallons').attr('data-type', product.typeHandle)

	});

	/// zero out the values

	// weight /rate
	modal.find('.row-weight-input').val(0)

	//bags and gallons
	modal.find("[data-dt-column='6'] td:nth-of-type(2)").text(0);
	modal.find("[data-dt-column='7'] td:nth-of-type(2)").text(0);

	//N P K
	modal.find("[data-dt-column='"+( showPricing ? 10 : 8)+"'] td:nth-of-type(2)").text(0);
	modal.find("[data-dt-column='"+( showPricing ? 11 : 9)+"'] td:nth-of-type(2)").text(0);
	modal.find("[data-dt-column='"+( showPricing ? 12 : 10)+"'] td:nth-of-type(2)").text(0);



} );

doc.on( 'change keyup paste click', '.dtr-bs-modal .row-weight-input', function () {

	$( '.btn-save' ).removeClass( 'disabled' );
	$('#save-scenario').addClass('dirty');

	modalCalcs()

} );

doc.on( 'blur', '.dtr-bs-modal .row-weight-input', function () {
	var val = $(this).val()
	$(this).val( Number(val).toFixed(1) )
});

doc.on( 'change keyup paste click', '.dtr-bs-modal .row-price-input', function () {
	$('#save-scenario').addClass('dirty');
	modalCalcs();
});

doc.on( 'click', '.fake-modal-footer button.cancel, .dtr-bs-modal .modal-header button.close', function () {

	modalFlag = true;

	$('.dtr-bs-modal').modal('hide')

	var modal = $('.dtr-bs-modal')
	var rowId = modal.find('.dt-row-id').text()
	var row = $('#' + rowId)

	// reset the select 2s
	row.find(".select2-container").remove()

	var week = modal.find('.product-week-select').val()
	row.find('.product-week-select').val(week).select2({
		width: '100%',
		minimumResultsForSearch: 99999,
	}).trigger('change')
	row.find('.read-only-details .product-week').text( weeksArray[week-1] )

	var productId = modal.find('.product-select').val()
	$('.dtr-bs-modal').find('.product-select').parent('div').addClass('visible-md-up')
	/// haaack. select leaves two containers behind. fix cause. someday.
	row.find('.product-select').val(productId).select2({
		width: "100%"
	}).trigger('change')

});

doc.on( 'click', '.fake-modal-footer button.done', function () {
	modalFlag = true;
	addModalDataToRow()
	$('.dtr-bs-modal').modal('hide')
});

doc.on('show.bs.modal','.dtr-bs-modal', function (event) {

	$( '.btn-save' ).removeClass( 'disabled' );
	$('#save-scenario').addClass('dirty');

	var showPricing = $('.show-pricing-hidden').val()

	// send the product data to the modal. for real-time calcs therein.
	$.getJSON( "/products.json", function(response) {
			var data = response.data;
			var product = data.filter(function( obj ) {
				return obj["id"] == productId;
			});
			product = product[0]
			$('.dtr-bs-modal .product-data').text( JSON.stringify(product) )
	});

	var modal = $('.dtr-bs-modal')

	if (showPricing) {
		modal.removeClass('hide-pricing')
	} else {
		modal.addClass('hide-pricing')
	}

	var rowId = modal.find('.dt-row-id').text()
	var row = $('#' + rowId)

	// set the values on the modal inputs that matter
	// others are calculated. delayed. maybe too much.

	var week = row.find('.product-week-select').find(':selected').val();

	if (week.toString().length == 1) {
		var paddedweek = "0" + week;
	} else {
		var paddedweek = week;
	}

	$( '#' + rowId + ' td:nth-of-type(2)' ).attr('data-order', paddedweek)

	//modal.find('.product-week-select').val(week).trigger('change')
	modal.find("[data-dt-column='1'] .select2-container").remove()
	modal.find('.product-week-select').val(week).select2({
		width: "100%"
	}).trigger('change')

	modal.find('.product-select').parent('div').removeClass('visible-md-up')
	var productId = row.find('.product-select').find(':selected').val();
	/// haaack. select leaves two containers behind. fix cause. someday.
	modal.find("[data-dt-column='3'] .select2-container").remove()
	modal.find('.product-select').val(productId).select2({
		width: "100%"
	}).trigger('change')

	var rate = row.find('.row-weight-input').val();
	modal.find('.row-weight-input').val(rate)

	var weightUnit = row.find('.weight-unit').html()
	modal.find('.weight-unit').html( weightUnit )

	var bags = row.find('.bags').text();
	modal.find("[data-dt-column='6'] td:nth-of-type(2)").text(bags);

	var gallons = row.find('.gallons').text();
	modal.find("[data-dt-column='7'] td:nth-of-type(2)").text(gallons);

	if (showPricing) {

		var price = row.find('.row-price-input').val();
		modal.find('.row-price-input').val(price)

		var cost = row.find('.cost').text();
		modal.find("[data-dt-column='9'] td:nth-of-type(2)").text(cost);

	}

	var nitrogen = row.find('.nitrogen').text();
	modal.find("[data-dt-column='"+( showPricing ? 10 : 8)+"'] td:nth-of-type(2)").text(nitrogen);

	var phosphorous = row.find('.phosphorous').text();
	modal.find("[data-dt-column='"+( showPricing ? 11 : 9)+"'] td:nth-of-type(2)").text(phosphorous);

	var potassium = row.find('.potassium').text();
	modal.find("[data-dt-column='"+( showPricing ? 12 : 10)+"'] td:nth-of-type(2)").text(potassium);

})

doc.on('click', '#scenario-table .refresher .refresh', function(){

	 scenarioTableDT.rows().invalidate();

	 scenarioTableDT.order([ 1, "asc" ]).draw();

});

doc.on('click', '#toggleCarryover', function(){
	updateChart(chartData);
})

//// TITLE ICON PSUEDO CLASS TOGGLER ETC. //////////////////////////

doc.on('focus','#scenario-title', function(){
	$('#scenario-title').removeClass('editable' )
})

doc.on('blur','#scenario-title', function(){
	$('#scenario-title').addClass('editable' )
})

doc.on('keyup','#scenario-title', function(){
	var text = $('#scenario-title').text()
	$('input[name="title"]').val(text)
})

/// PRODUCT INFO DETAIL MODAL

doc.on('show.bs.modal','#product-info-modal', function( event){
	var button = $(event.relatedTarget) // Button that triggered the modal
	var row = button.closest('tr')

	var productTitle = button.siblings('.product-detail-title').text()
	var productDescription = button.siblings('.product-detail-description').text()
	var productCategory = button.siblings('.product-category').text()
	var partCode = button.siblings('.part-code').text()
	var partCodeLegacy = button.siblings('.part-code-legacy').text()
	var labelUrl = button.siblings('.label-url').text()
	var productWeight = button.siblings('.product-weight').text()
	var productCountry = button.siblings('.product-country').text()
	var productSgn = button.siblings('.product-sgn').text()

	//return console.log(productid);
	var modal = $('#product-info-modal')

	modal.find('.part-title').html(productTitle);
	// modal.find('.part-desc').html(productDescription);
	modal.find('.category').html("<strong>Category: </strong>" + (productCategory ? productCategory : "--") );
	modal.find('.part-code').html("<strong>Product Code: </strong>" + (partCodeLegacy ? partCodeLegacy : "--") + " / " + (partCode ? partCode : "--") );

	var html = "<strong>Package Weight (" + (productCountry == 'us' ? 'lbs' : 'kg') + "): </strong>" + productWeight + "<br/>"
	html += "<strong>SGN Size: </strong>" + productSgn + "<br/>"
	if ( labelUrl ) {
		html += "<strong>Label: </strong><a href='" + labelUrl + "' target='_blank'>Download</a><br/>"
	} else {
		html += "<strong>Label: </strong>--<br/>"
	}
	//html += "<strong>Sheet: </strong>" + sheet + "<br/>"
	html += "<strong>SDS: </strong>--<br/>"

	modal.find('.modal-body').html(html);

	//modal.find('.type').html("<strong>Type: </strong>" + product['Type']);

})

/// ROW COPY MODAL

doc.on('show.bs.modal','#row-copy-modal', function( event){

	var entryId = $(event.relatedTarget).data('entry-id')

	var data = {
		entryId: entryId
	};

	// include csrf token
	var tokenName = window.csrfTokenName;
	data[ tokenName ] = window.csrfTokenValue;

	$.ajax( {
		type: "post",
		data: data,
		url: '/actions/tnt/scenarios/save-entry',
		success: function ( response ) {
		//console.log(response)
		},
		error: function ( XMLHttpRequest, textStatus ) {
		console.log( "Status: " + textStatus );
		}
	} );

	var button = $(event.relatedTarget) // Button that triggered the modal
	var row = button.closest('tr') // Extract info from data-* attributes

	$('.week').text( row.find('.product-week-select').val() )
	$('.productId').text( row.find('.product-select').val() )
	$('.rate').text( row.find('.row-weight-input').val() )
	$('.price').text( row.find('.row-price-input').val() )
	$('.productType').text( row.find('td.product-type').text() )

})

$('.row-copy-apply').on('click', function() {

	$('#save-scenario').addClass('dirty');

	$( '.btn-save' ).removeClass( 'disabled' );

	var turfType = $('.turf-type-hidden').val();
	var country =  $('.country-hidden').val();

	var week = $('.week').text()
	var productId = $('.productId').text()
	var rate = $('.rate').text()
	var price = $('.price').text()
	var productType = $('.productType').text()

	var copies = $('.row-copy-weeks').val()
	var interval = $('.row-copy-interval').val()

	if (productType == "Foliar") {
		productType = ['foliar','foliarSg']
	}

	var data = {
		productType: productType,
		turfType: turfType,
		country: country,
		week: week,
		productId: productId,
		rate: rate,
		price: price,
		copies: copies,
		interval: interval
	};

	// include csrf token
	var tokenName = window.csrfTokenName;
	data[ tokenName ] = window.csrfTokenValue;

	$.ajax( {
		type: "post",
		url: '',
		data: data,
		url: '/actions/tnt/scenarios/get-products-by-type',
		success: function ( response ) {
			duplicateRows( JSON.parse( response ), data );
		},
		error: function ( XMLHttpRequest, textStatus ) {
			console.log( "Status: " + textStatus );
		}
	} );
	
	// $('#row-copy-modal').modal('hide')

})
